import './copy_to_clipboard';
import './autosubmit';
import './export';
import './strava_status';
import './stripe';
import './user_timezone_formatting';

// When clicking on #hamburger add .show to #hamburger and .mobilemenu
// When clicking on #hamburger.show remove .show from #hamburger and .mobilemenu
const hamburger = document.getElementById('hamburger');
const mobileMenuItems = document.querySelectorAll('.mobilemenu');

// Add a click event listener to the hamburger element
if (hamburger) {
    hamburger.addEventListener('click', function () {
        // Toggle the 'show' class for the hamburger element
        hamburger.classList.toggle('show');

        // Toggle the 'show' class for all elements with the 'mobilemenu' class
        mobileMenuItems.forEach((item) => {
            item.classList.toggle('show');
        });
    });
}
